<template>
  <div class="pa-5" data-testid="dev-console">
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center justify-start md-header">
          <div class="mr-4">Random Functions</div>
          <v-progress-circular
            v-if="loading"
            :indeterminate="true"
            size="25"
            width="3"
            :color="this.setBlackIfTooLight(this.randomColor())"
          />
        </div>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="updateSanmarInfo"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >update Sanmar Info</v-btn
        >
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="getTotalWebsiteSales"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >get Total Website Sales</v-btn
        >
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="getOrderedProductNotInStore"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >get Ordered Product Not In Store</v-btn
        >
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="getSmartProductCountSinceLaunch"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >get Smart Product Count Since Launch</v-btn
        >
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="testEmail"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >test email</v-btn
        >
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="getDistributorInfo"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >get distributor info</v-btn
        >
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="getSalesRepInfo"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >get sales rep info</v-btn
        >
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="sendExtendStoreEmails"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >send extend store emails to client contacts</v-btn
        >
      </v-col>
      <v-col cols="12" class="mt-5">
        <div class="md-header">🚫⚠️ Danger Zone ⚠️🚫</div>
        <i
          >These functions have an immediate and permanent effect on the
          database and should only be used when absolutely certain.</i
        >
        <br />
        <i>You must manually enable them in the codebase to use them</i>
        <v-spacer />
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <v-btn
          variant="flat"
          @click="createBatchesForCompleteStores"
          :style="randomButtonColorStyle()"
          :disabled="loading"
          >create batches for complete stores</v-btn
        >
      </v-col>
      <v-dialog v-model="showInfo" max-width="75vw" scrollable persistent>
        <v-card class="pa-2">
          <v-card-title>
            <div class="d-flex align-center">
              <div class="dev-console-result-title">
                {{ showInfoDialogTitle }} response:
              </div>
              <v-spacer />
              <v-tooltip location="bottom">
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="plain" v-bind="props" @click="copyDataToClipboard">
                    <v-icon icon="content_copy" />
                  </v-btn>
                </template>
                <span> Copy to Clipboard </span>
              </v-tooltip>
              <v-tooltip location="bottom">
                <template v-slot:activator="{ props }">
                  <a
                    href="https://jsonformatter.curiousconcept.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    v-bind="props"
                    style="text-decoration: none"
                  >
                    <v-btn icon variant="plain"><v-icon icon="code" /></v-btn>
                  </a>
                </template>
                <span> Open JSON Formatter </span>
              </v-tooltip>
              <v-tooltip location="bottom">
                <template v-slot:activator="{ props }">
                  <a
                    href="https://products.aspose.app/cells/conversion/json-to-excel"
                    target="_blank"
                    rel="noopener noreferrer"
                    v-bind="props"
                    style="text-decoration: none"
                  >
                    <v-btn icon variant="plain"><v-icon icon="table_chart" /></v-btn>
                  </a>
                </template>
                <span> Open JSON to CSV Formatter </span>
              </v-tooltip>
              <v-tooltip location="bottom">
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="plain" @click="showInfo = false" v-bind="props">
                    <v-icon icon="close" />
                  </v-btn>
                </template>
                <span> Close </span>
              </v-tooltip>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="code-snippet">
              {{ resultInfo }}
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <img
        class="memeball"
        src="https://i.kym-cdn.com/entries/icons/original/000/021/703/smiley-face-thumbs-up-thank-you-clipart-panda-free-clipart-images-4eZHzt-clipart.jpeg"
      />
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        top
        :color="this.setBlackIfTooLight(this.randomColor())"
      >
        Text Copied to Clipboard
      </v-snackbar>
    </v-row>
  </div>
</template>

<script>
import { describeError } from "@/utils/safeErrorLog";
import rules from "@/mixins/rules";
import helpers from "@/mixins/helpers";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      resultInfo: null,
      showInfo: false,
      showInfoDialogTitle: "",
      snackbar: false,
      timeout: 2500,
      loading: false,
    };
  },

  mixins: [rules, helpers],

  props: {},

  async mounted() {
    this.$store.state.title = "Developer Console";
  },

  watch: {
    showInfo: {
      handler() {
        if (!this.showInfo) {
          this.showInfoDialogTitle = "";
          this.resultInfo = null;
        }
      },
    },
  },

  methods: {
    copyDataToClipboard() {
      navigator.clipboard.writeText(JSON.stringify(this.resultInfo));
      this.snackbar = true;
    },

    showInfoDialog(title, info) {
      this.resultInfo = info;
      this.showInfoDialogTitle = title;
      this.showInfo = true;
    },

    randomButtonColorStyle() {
      let background = this.setBlackIfTooLight(this.randomColor());
      return `background-color: ${background}; color: white; border-radius: 2px; width: 98%`;
    },

    async sendExtendStoreEmails() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/sendExtendEmailsToClientContacts",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        console.log("response status", response && response.status);
        this.loading = false;
        this.showInfoDialog("sendExtendStoreEmails", response.data);
      }
    },

    async getDistributorInfo() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/getDistributorInfo",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        console.log("response status", response && response.status);
        this.loading = false;
        this.showInfoDialog("getDistributorInfo", response.data);
      }
    },

    async getSalesRepInfo() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post("/admin_console/getSalesRepInfo", {});
      } catch (err) {
        console.log(describeError(err));
      } finally {
        console.log("response status", response && response.status);
        this.loading = false;
        this.showInfoDialog("getSalesRepInfo", response.data);
      }
    },

    async testEmail() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post("/admin_console/sendTestEmail", {});
      } catch (err) {
        console.log(describeError(err));
      } finally {
        console.log("response status", response && response.status);
        this.loading = false;
        this.showInfoDialog("testEmail", response.data);
      }
    },

    async getSmartProductCountSinceLaunch() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/getSmartProductCountSinceLaunch",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        this.showInfoDialog("getSmartProductCountSinceLaunch", response.data);
        console.log("response status", response && response.status);
        this.loading = false;
      }
    },

    async getTotalWebsiteSales() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/getTotalWebsiteSales",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        this.showInfoDialog("getTotalWebsiteSales", response.data);
        console.log("response status", response && response.status);
        this.loading = false;
      }
    },

    async getOrderedProductNotInStore() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/getOrderedProductNotInStore",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        this.showInfoDialog("getOrderedProductNotInStore", response.data);
        console.log("response status", response && response.status);
        this.loading = false;
      }
    },

    async updateSanmarInfo() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/updateSanmarInfo",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        this.showInfoDialog("updateSanmarInfo", response.data);
        console.log("response status", response && response.status);
        this.loading = false;
      }
    },

    async convertAddedCostsToNewSchema() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/convertAddedCostsToNewSchema",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        console.log("response status", response && response.status);
        this.loading = false;
      }
    },

    async createBatchesForCompleteStores() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(
          "/admin_console/createBatchesForCompleteStores",
          {}
        );
      } catch (err) {
        console.log(describeError(err));
      } finally {
        console.log("response status", response && response.status);
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.memeball {
  width: 100px;
  height: 100px;
  position: fixed;
  bottom: 25px;
  left: 25px;
}
.dev-console-result-title {
  font-family: "Lucida Console", "Courier New", monospace;
  font-size: 16px;
  font-weight: bold;
}
</style>


